package io.github.jangalinski.pages._2015._10._05

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initBuzzwordClockPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2015/10/05/BuzzwordClock.md", FrontMatterElement.Builder { addScalar("title", "Building a BuzzwordClock with Reactor, Atmosphere, Spring-Boot and Vaadin"); addScalar("date", "2015-10-05"); }))
}

@Page("/2015/10/05/buzzword-clock")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun BuzzwordClockPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Recently I started working with reactive streams and event based systems using ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://projectreactor.io/") {
            org.jetbrains.compose.web.dom.Text("projectreactor.io")
        }
        org.jetbrains.compose.web.dom.Text(". I thought it would be nice to use an event based approach to communicate between UI and server, so I dug around a bit and found vaadin-spring and vaadin-push.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("So here is my buzzword-clock, a single file application that shows the current time using as many fancy technologies as possible:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Spring Boot with web-starter")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Spring @Scheduled for the ticking clock")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("vaadin spring for the UI")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("vaadin push with atmosphere for updating the web-UI from the server")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Reactor for the (async) EventBus.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For a full pom.xml, check out the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski/springboot-playground") {
            org.jetbrains.compose.web.dom.Text("repo")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("center") {
        org.jetbrains.compose.web.dom.Text("""![the clock in action](/img/buzzwordclock.png)
""")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The embedded gist from the original post is still available here: ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://gist.github.com/d102ee410961bd1d607d") {
            org.jetbrains.compose.web.dom.Text("d102ee410961bd1d607d")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("main-building-blocks") }) {
        org.jetbrains.compose.web.dom.Text("Main Building blocks")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It is a spring-boot application, starting an embedded tomcat servlet container.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It defines a Vaadin UI spring bean that is discovered and bound to \"/\"")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The \"clock\" bean is scheduled, its method is triggered every second.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Using the reactor framework, it defines an Environment and an EventBus bean that loosly couples the server and the UI.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Every second an event is fired (notify) containing the current local time as payload")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The UI consumes the localtime event and updates the label with the formatted time")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("thanks-to") }) {
        org.jetbrains.compose.web.dom.Text("Thanks to")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For the push part, I leveraged the ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://www.sothawo.com/2015/06/using-server-push-in-a-vaadin-app/") {
            org.jetbrains.compose.web.dom.Text("Using Server-Push in a Vaadin app")
        }
        org.jetbrains.compose.web.dom.Text(" example by P.J.Meisch.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("open-points") }) {
        org.jetbrains.compose.web.dom.Text("Open points")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Seams like I didn't get the @EnableReactor annotation ... I had to configure the reactor environment in a static block.")
    }
}
